// extracted by mini-css-extract-plugin
export default {"controller":"UpAnimatie_controller__9QjIM","bounce-down":"UpAnimatie_bounce-down__jkjwx","img":"UpAnimatie_img__MLmeu"};